import {h, Component} from 'preact';
export default class Chat extends Component {
    render() {
        let {color, size} = this.props
        return (
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
                <path fill={color} d="M6.05,39a2,2,0,0,1-1.79-2.83l2.5-5.31A17.54,17.54,0,1,1,13,36.75L6.69,38.89A1.94,1.94,0,0,1,6.05,39Zm-.47-3.41h0Zm7.19-1.94a1.81,1.81,0,0,1,1,.28,14.64,14.64,0,1,0-4.13-3.88,1.84,1.84,0,0,1,.17,1.85L8.3,35.08l3.89-1.33A1.81,1.81,0,0,1,12.77,33.65Z"/>
                <path fill={color} d="M29.45,17H14.55a1.46,1.46,0,1,1,0-2.91H29.45a1.46,1.46,0,1,1,0,2.91Z"/>
                <path fill={color} d="M29.45,23H14.55a1.46,1.46,0,1,1,0-2.91H29.45a1.46,1.46,0,1,1,0,2.91Z"/>
                <path fill={color} d="M29.45,29H14.55a1.46,1.46,0,1,1,0-2.91H29.45a1.46,1.46,0,1,1,0,2.91Z"/>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/Chat.js